import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './design-system/global.css';
import './i18n';
import { App } from './app/App';

async function start() {
  // A literal check, so normal builds drop the fixtures chunk entirely.
  if (import.meta.env.VITE_FIXTURES === '1') {
    const { startFixtures } = await import('./fixtures/browser');
    await startFixtures();
  }
  const el = document.getElementById('root');
  if (!el) throw new Error('#root is missing from index.html');
  createRoot(el).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}

void start();
